var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Heard'),_c('div',{staticClass:"banner container-fluid",staticStyle:{"margin":"0 auto"}}),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannercont container-fluid"},[_c('img',{staticClass:"container-fluid",staticStyle:{"margin":"0 auto"},attrs:{"src":require("@/assets/image/ourcont.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }